;(function () {
  angular
    .module('contrast.date')
    .directive('csDateRangePickerPrimary', csDateRangePickerPrimary)

  function csDateRangePickerPrimary($timeout, csDateRangePickerService) {
    'ngInject'

    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'views/cs-date-range-picker-primary.html',
      controller: 'csDateRangePickerPrimaryCtrl',
      controllerAs: 'csDateRangePickerPrimaryCtrl',
      bindToController: {
        extraOptions: '=?',
        csDateRangeType: '@?',
        csDateRangeOptionsKey: '@?',
        e2eTestId: '@?'
      },
      require: ['^ngModel', '^csDateRangePickerPrimary'],
      scope: {},
      link: function ($scope, elem, attrs, ctrls) {
        var ngModelCtrl = ctrls[0]
        var csDateRangePickerPrimaryCtrl = ctrls[1]
        csDateRangePickerPrimaryCtrl.propagateModelChange = function () {
          $timeout(function () {
            ngModelCtrl.$setViewValue(csDateRangePickerPrimaryCtrl.model)
            _updateRangeInputModelView(
              elem,
              csDateRangePickerPrimaryCtrl.model,
              attrs.hasOwnProperty('timePicker')
            )
          })
        }
        csDateRangePickerPrimaryCtrl.timePicker =
          attrs.hasOwnProperty('timePicker')

        $scope.$watch(
          function () {
            return ngModelCtrl.$modelValue
          },
          function (newVal) {
            if (
              newVal &&
              (!csDateRangePickerPrimaryCtrl.model ||
                !isSameDateModel(csDateRangePickerPrimaryCtrl.model, newVal))
            ) {
              csDateRangePickerPrimaryCtrl.updateModel(newVal)
            }
          }
        )
      }
    }

    function _updateRangeInputModelView(elem, model, formatWithTime) {
      var inputNgModelCtrl = elem.find('input').controller('ngModel')
      var view = csDateRangePickerService.formatModelToView(
        model,
        formatWithTime
      )
      inputNgModelCtrl.$setViewValue(view)
    }

    function isSameDateModel(a, b) {
      return a.startDate == b.startDate && a.endDate == b.endDate
    }
  }
})()
